<img [src]="image | resizeImage: [150, 150]" loading="lazy" />

<app-lot-add-photo-uploading-list-item-preview-overlay
  [isAuctionList]="isAuctionList"
  (remove)="remove.emit()"
  (openPreview)="openPreview.emit()"
  (setAsAuctionList)="setAsAuctionList.emit()"
></app-lot-add-photo-uploading-list-item-preview-overlay>
